import React, {useState} from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../store'
import {ErrorComponent, FullLoader} from '../common'
import {i18n}  from '../../i18n'
import EditSideEffect from './components/EditSideEffect'
import ListPageLayout from '../common/layout/ListPageLayout'
import {usePagination} from '../../utils/hooks/usePagination'
import SideEffectsTable from './components/SideEffectsTable'
import {TablePaginationConfig} from 'antd'
import {AnyObj, SearchDto} from '../../utils/types'
import {SearchComponentType} from '../../utils/enums'
import SearchComponent from '../common/SearchComponent'

const SideEffectsPage = observer(() => {
    const {sideEffectStore} = useStores()
    const [searchList, setSearchList] = useState<AnyObj>({})
    const [sortField, setSortField] = useState<string>()
    const [sortOrder, setSortOrder] = useState<string>()
    const [loading, paginationConfig] = usePagination(sideEffectStore, searchList, sortField, sortOrder)

    if (sideEffectStore.dataList === null) {
        return <FullLoader />
    }

    if (sideEffectStore.dataList === undefined) {
        return <ErrorComponent status={404} />
    }

    const searchParams: SearchDto[] = [
        {
            type: SearchComponentType.INPUT,
            searchParam: 'sideEffectName',
            placeholder: i18n.t('sideEff.title'),
        },
    ]

    const handleTableChange = (pagination: TablePaginationConfig, filters: any, sorter: any) => {
        setSortField(sorter.field)
        setSortOrder(sorter.order)
    }

    return (
        <ListPageLayout title={i18n.t('sideEff.pageTitle')} createModalTitle={i18n.t('sideEff.create')} createModal={EditSideEffect}>
            <SearchComponent searchParams={searchParams} onChangeFilter={setSearchList}/>
            <SideEffectsTable data={sideEffectStore.dataList} loading={loading} pagination={paginationConfig} onTableChange={handleTableChange} />
        </ListPageLayout>
    )
})

export default SideEffectsPage
